export default "__VITE_ASSET__5ffdafa2__"